export const STORE_URL_ANDROID = 'https://redirect.appmetrica.yandex.com/serve/98949160845199629';
export const STORE_URL_ANDROID_DEEPLINK = 'https://redirect.appmetrica.yandex.com/serve/675343009067382139?id={id}';
export const STORE_URL_IOS =
    'https://3474082.redirect.appmetrica.yandex.com/start?appmetrica_tracking_id=98949160845199629';
export const STORE_URL_IOS_DEEPLINK =
    'https://3474082.redirect.appmetrica.yandex.com/j/{id}?appmetrica_tracking_id=675343009067382139';
export const IGNORE_DEVICE_IDS: Set<string> = new Set(['communications']);
